import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getPlanzoneResources() {
      return getState().resources;
    },
    isPlanzoneResourcesRetrievalRequestFailure() {
      return getState().request.isFailure;
    },
    isPlanzoneResourcesRetrievalRequestPending() {
      return getState().request.isPending;
    },
    isPlanzoneResourcesRetrievalRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
